import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "bag",
  "use": "bag-usage",
  "viewBox": "0 0 16 14",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 14\" id=\"bag\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M6.25 2.75c0-.543.619-1.25 1.75-1.25s1.75.707 1.75 1.25h1.5C11.25 1.084 9.63 0 8 0S4.75 1.084 4.75 2.75h1.5zM0 3.75a1 1 0 011-1h14a1 1 0 011 1V7h-4.25v-.25a.75.75 0 00-1.5 0V7h-4.5v-.25a.75.75 0 00-1.5 0V7H0V3.75zM11.75 8.5H16v4.25a1 1 0 01-1 1H1a1 1 0 01-1-1V8.5h4.25v.25a.75.75 0 001.5 0V8.5h4.5v.25a.75.75 0 001.5 0V8.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol